import React from 'react'

const Card = (props) => {
  return (
    <div className='card'>
      {props.children}
    </div>
  )
}
export default Card
